module.exports = __webpack_public_path__ + "img/1x.2f64da4.jpg";